module.exports = __webpack_public_path__ + "img/4.a7ad89a2.png";